import { classMap, Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { GraphOptions } from '@rxdi/ui-kit/graph';
import { from } from 'rxjs';

const style = css`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    cursor: pointer;
  }

  li {
    float: left;
  }

  li a {
    display: block;
    color: #6b7873;
    text-align: center;
    padding: 16px;
    text-decoration: none;
  }

  li a:hover {
    color: white;
  }

  .white {
    color: white;
  }
`;

/**
 * @customElement generic-navbar-component
 */
@Component({
  selector: 'generic-navbar-component',
  style,
  template(this: GenericNavbarComponent) {
    return html`
      <div style="padding: 10px;">
        <ul>
          <rx-graph
            .options=${{
              style,
              state: from(this.items),
              render: (items) => html`
                ${items.map(
                  (i) => html`
                    <li @click=${() => this.router.go(i.value)}>
                      <a
                        class=${classMap({
                          white: this.includes ? i.value.includes(this.includes) : this.router.activePath === i.value,
                        })}
                        >${i.key}</a
                      >
                    </li>
                  `
                )}
              `,
            } as GraphOptions}
          ></rx-graph>
        </ul>
      </div>
    `;
  },
})
export class GenericNavbarComponent extends LitElement {
  @Router() private router: Router;
  @property({ type: Array }) items: Promise<{ key: string; value: string }[]> | { key: string; value: string }[] = [];

  @property({ type: String })
  includes: string;
}
